import { fmtStamp } from '../components/LiveClock';

const inr = (n) => `₹${(Number(n) || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;

export function receiptText(row, { recordedAt } = {}) {
  const isDebit = row.type === 'debit';
  const bal = Number(row.running_balance) || 0;
  return [
    `*${row.store_name || 'BharatCart shop'}* — Khata receipt`,
    row.customer_name ? `Customer: ${row.customer_name}` : null,
    `Serial: ${row.txn_serial || '—'}`,
    `${isDebit ? 'Udhaar added' : 'Payment received'}: ${inr(row.amount)}`,
    row.note ? `Note: ${row.note}` : null,
    `Date: ${fmtStamp(recordedAt || row.created_at)}`,
    recordedAt ? `(recorded offline, synced ${fmtStamp(row.created_at)})` : null,
    bal > 0 ? `Balance due: ${inr(bal)}` : 'No balance due. Thank you!',
    '— sent via BharatCart Digital Khata',
  ].filter(Boolean).join('\n');
}

export function receiptWaUrl(row, opts) {
  const digits = String(row.customer_phone || '').replace(/\D/g, '');
  const to = digits.length === 10 ? `91${digits}` : digits;
  return `https://wa.me/${to}?text=${encodeURIComponent(receiptText(row, opts))}`;
}
